import React, { useState } from 'react';
import {
  Container, Col, Row, Button, Form
} from 'react-bootstrap';
import Header from '../Header';
import Footer from '../Footer';
import { Link } from 'react-router-dom';
import { Organization } from '../../Services/Organization';
import { NotificationManager } from 'react-notifications';
import ActionButton from '../ActionButton';
import { staticData } from '../../helpers/data';
import { sanitize, validateFormFields } from '../../utils/validationUtils';

const OrgSignupStepTwo = ({ nextStep, prevStep, handleFormData, handleContactBy, values }) => {
  const [fieldErrors, setFieldErrors] = useState({});

  const submitFormData = (e) => {
    e.preventDefault();

    const sanitizedData = {
      first_name: sanitize(values.first_name),
      last_name: sanitize(values.last_name),
      email: sanitize(values.email),
      phone: sanitize(values.phone),
      department: sanitize(values.department),
      timezone: sanitize(values.timezone),
    };

    const errors = validateFormFields(sanitizedData);
    setFieldErrors(errors);

    if (Object.keys(errors).length > 0) {
      const firstError = Object.values(errors)[0];
      NotificationManager.error(firstError, 'error!', 2000);
      return;
    }

    Organization.sendEmail({ email: sanitizedData.email, in_register: true }).then(
      (data) => {
        if (data.error === 0) {
          NotificationManager.success(data.message, 'success!', 2000);
          nextStep();
        }
      },
      (error) => NotificationManager.error(error.toString(), 'error!', 2000)
    );
  };

  return (
    <>
      <Header />
      <section className="login-body" style={{ backgroundImage: 'url("images/signup-bg.jpg")' }}>
        <Container>
          <Row>
            <Col md={12}>
              <div className="step-progress">
                <div className="step-progress-bar">
                  <div className="step-progress-percent" style={{ width: '50%' }}></div>
                </div>
                <div className="step-progress-text">
                  <h6>Profile Creation</h6>
                  <h6>50% Completed</h6>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={9}>
              <div className="signup-box">
                <div className="signup-left">
                  <h4>{staticData?.verbiage?.company[2]?.heading}</h4>
                  <p dangerouslySetInnerHTML={{ __html: staticData?.verbiage?.company[2]?.text }} />
                  <div className="signup-step" style={{ marginTop: 260 }}>
                    <ul><li></li><li className="active"></li><li></li><li></li></ul>
                  </div>
                </div>
                <div className="signup-right">
                  <Form onSubmit={submitFormData}>
                    <div className="add-details">
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" name="first_name" onChange={handleFormData("first_name")} defaultValue={values.first_name} placeholder="Point of contact First Name*" />
                            <span className="err">{fieldErrors.first_name}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" name="last_name" onChange={handleFormData("last_name")} defaultValue={values.last_name} placeholder="Point of contact Last Name*" />
                            <span className="err">{fieldErrors.last_name}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" name="department" onChange={handleFormData("department")} defaultValue={values.department} placeholder="Department*" />
                            <span className="err">{fieldErrors.department}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="tel" name="phone" onChange={handleFormData("phone")} defaultValue={values.phone} placeholder="Company Main Phone Number" />
                            <span className="err">{fieldErrors.phone}</span>
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Control type="email" name="email" onChange={handleFormData("email")} defaultValue={values.email} placeholder="Your Company Email Address" />
                            <span className="err">{fieldErrors.email}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" defaultValue={values.company_name} placeholder="Company Name*" readOnly />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Select name="timezone" onChange={handleFormData("timezone")} defaultValue={values.timezone}>
                              <option disabled value=''>Select Time Zone*</option>
                              <option value="EST">EST</option>
                              <option value="CST">CST</option>
                              <option value="PST">PST</option>
                            </Form.Select>
                            <span className="err">{fieldErrors.timezone}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" defaultValue={values.company_ein} placeholder="EIN*" readOnly />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" defaultValue={values.company_address} placeholder="Company Address*" readOnly />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" defaultValue={values.company_city} placeholder="City*" readOnly />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" defaultValue={values.company_state} placeholder="State*" readOnly />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" defaultValue={values.company_zip} placeholder="Zip Code*" readOnly />
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="iagree mb-3" controlId="formbymail">
                            <Form.Check className="text-grey" name="contact_by" type="checkbox" onChange={handleContactBy('contact_by')} checked={values.contact_by.includes('email')} label="Contact Me By Email" value="email" />
                          </Form.Group>
                          <Form.Group className="iagree mb-3" controlId="formbyphone">
                            <Form.Check className="text-grey" name="contact_by" type="checkbox" onChange={handleContactBy('contact_by')} checked={values.contact_by.includes('phone')} label="Contact Me By Phone" value="phone" />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                    <div className="signup-back-btn">
                      <Link onClick={prevStep} to="#" className="btn btn-link">Back</Link>
                      <ActionButton type={'submit'} className={'btn btn-primary btn-pill px-4'} title={'Continue'} requiredFields={[values.first_name, values.last_name, values.phone, values.email, values.department]} />
                    </div>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default OrgSignupStepTwo;
